import { FaArrowsAltH, FaArrowsAltV, FaMinus } from 'react-icons/fa';
import {
  ImArrowDown,
  ImArrowLeft,
  ImArrowRight,
  ImArrowUp,
} from 'react-icons/im';

import { ColorPickerField } from '../components/ColorPickerField';

import { BottomBarSelect } from '../components/BottomBarSelect';
import DynamicIcon from '../components/DynamicIcon';
import { IconField } from '../components/IconField';
import slate from '../packages/plugins/content/slate';

const defaultSlate = slate();

const navigationElementPlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div
      className="navigationElement-outer"
      style={{
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
        paddingLeft: data?.style?.paddingHorizontal,
        paddingRight: data?.style?.paddingHorizontal,
      }}
    >
      <div
        className="navigation-elem-top"
        style={{
          fontSize: 42,
          textAlign: 'center',
          display: 'flex',
        }}
      >
        {data?.arrows?.top === 'Outgoing' && (
          <ImArrowUp color={data?.arrows?.topArrowColor} />
        )}
        {data?.arrows?.top === 'Ingoing' && (
          <ImArrowDown color={data?.arrows?.topArrowColor} />
        )}
        {data?.arrows?.top === 'Double headed' && (
          <FaArrowsAltV color={data?.arrows?.topArrowColor} />
        )}
        {data?.arrows?.top === 'Simple line' && (
          <FaMinus
            style={{ rotate: '90deg' }}
            color={data?.arrows?.topArrowColor}
          />
        )}
      </div>

      <div
        className="navigation-elem-mid"
        style={{
          display: 'flex',
          width: '100%',
        }}
      >
        <div
          className="navigation-elem-mid-left"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 42,
            margin: '0',
          }}
        >
          {data?.arrows?.left === 'Outgoing' && (
            <ImArrowLeft color={data?.arrows?.leftArrowColor} />
          )}
          {data?.arrows?.left === 'Ingoing' && (
            <ImArrowRight color={data?.arrows?.leftArrowColor} />
          )}
          {data?.arrows?.left === 'Double headed' && (
            <FaArrowsAltH color={data?.arrows?.leftArrowColor} />
          )}
          {data?.arrows?.left === 'Simple line' && (
            <FaMinus color={data?.arrows?.leftArrowColor} />
          )}
        </div>

        <div
          className="navigationElement-content"
          style={{
            display: 'flex',
            background: data?.style?.backgroundColor
              ? data?.style?.backgroundColor
              : '#fff',
            padding: '10px 15px',
            borderRadius: '0px',
            width: '100%',
            // maxWidth: "400px",
            alignItems: 'center',
            margin: '0px auto',
          }}
        >
          {data?.style?.hideIcon ? null : (
            <div
              className="navigationElement-icon"
              style={{
                fontSize: '5rem',
                background: data?.style?.iconBackground,
                borderRadius: '24px',
                padding: '9px 14px 0px',
              }}
            >
              {' '}
              <DynamicIcon
                color={data?.style?.iconColor}
                iconName={data?.style?.icon ?? 'Valve'}
              />
            </div>
          )}
          <div
            className="navigationElement-text"
            style={{
              paddingLeft: 10,
              width: '90%',
              color: data?.style?.textColor,
              paddingRight: 10,
            }}
          >
            {children}
          </div>
        </div>

        <div
          className="navigation-elem-mid-right"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 42,
            margin: '0',
          }}
        >
          {data?.arrows?.right === 'Outgoing' && (
            <ImArrowRight color={data?.arrows?.rightArrowColor} />
          )}
          {data?.arrows?.right === 'Ingoing' && (
            <ImArrowLeft color={data?.arrows?.rightArrowColor} />
          )}
          {data?.arrows?.right === 'Double headed' && (
            <FaArrowsAltH color={data?.arrows?.rightArrowColor} />
          )}
          {data?.arrows?.right === 'Simple line' && (
            <FaMinus color={data?.arrows?.rightArrowColor} />
          )}
        </div>
      </div>

      <div
        className="navigation-elem-bottom"
        style={{
          fontSize: 42,
          textAlign: 'center',
          display: 'flex',
        }}
      >
        {data?.arrows?.bottom === 'Outgoing' && (
          <ImArrowDown color={data?.arrows?.bottomArrowColor} />
        )}
        {data?.arrows?.bottom === 'Ingoing' && (
          <ImArrowUp color={data?.arrows?.bottomArrowColor} />
        )}
        {data?.arrows?.bottom === 'Double headed' && (
          <FaArrowsAltV color={data?.arrows?.bottomArrowColor} />
        )}
        {data?.arrows?.bottom === 'Simple line' && (
          <FaMinus
            style={{ rotate: '90deg' }}
            color={data?.arrows?.bottomArrowColor}
          />
        )}
      </div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h1,
                children: ['Title'],
              },
              {
                plugin: plugins.headings.h3,
                children: ['Subtitle'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'navigationElement-plugin',
  title: 'Process Box Squared',
  // description: 'emergency content plugin',
  version: 1,
  controls: [
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                hideIcon: {
                  type: 'boolean',
                  default: false,
                },
                backgroundColor: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Background Color: ',
                  },
                },
                icon: {
                  type: 'string',
                  default: 'Valve',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'tranpsarent',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon Background Color: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                textColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Text Color: ',
                  },
                },
                paddingHorizontal: {
                  type: 'number',
                  default: 0,
                },
              },
            },
          },
        },
      },
    },
    {
      title: 'Arrows',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            arrows: {
              type: 'object',
              required: [],
              properties: {
                top: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Top:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
                topArrowColor: {
                  type: 'string',
                  default: 'rgba(34,34,34,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Top Arrow Color: ',
                  },
                },
                right: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Right:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
                rightArrowColor: {
                  type: 'string',
                  default: 'rgba(34,34,34,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Right Arrow Color: ',
                  },
                },
                bottom: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Bottom:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
                bottomArrowColor: {
                  type: 'string',
                  default: 'rgba(34,34,34,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Bottom Arrow Color: ',
                  },
                },
                left: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Left:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
                leftArrowColor: {
                  type: 'string',
                  default: 'rgba(34,34,34,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Left Arrow Color: ',
                  },
                },
              },
            },
          },
        },
      },
    },
  ],
};
export default navigationElementPlugin;
